import React, {Component} from 'react';
import '../styles/Home.css'
import {Link} from "react-router-dom";

export default class Error extends Component {

    render() {
        return <div className="home">
            <div style={{paddingTop: 150, textAlign: 'center', color: '#696969'}}><h4>Nie ma takiej strony.</h4>
                <p>Przejdź do <Link to={'/'}>strony głównej</Link>.</p></div>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/home/Error.js